import React, { useEffect } from 'react';
import SEOTable from '../components/SEO';

const SEOComponent = () => {
  return <SEOTable />;
};

export default SEOComponent;
